import { render } from "./PlatformTwo.vue?vue&type=template&id=0ceff80b"
import script from "./PlatformTwo.vue?vue&type=script&lang=js"
export * from "./PlatformTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__